module.exports = __webpack_public_path__ + "stockLibrary/landing-modal-img-2-d8a0eccacba807c07c2b969665e8305e.png";